import React from 'react';
import PageLayout from '../components/PageLayout';

/**
 * Partners page component
 */
const PartnersPage: React.FC = () => {
  return (
    <PageLayout 
      title="Our Partners" 
      subtitle="Working together to improve the golfing experience"
      backgroundImage="https://images.pexels.com/photos/6580167/pexels-photo-6580167.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section>
        <h2>Golf Course Partners</h2>
        <p>
          We work with over 200 premier golf courses nationwide to provide our users with exceptional 
          golfing experiences. Our partnership program offers courses increased visibility, streamlined 
          booking management, and access to our growing community of passionate golfers.
        </p>
        
        <div className="blog-posts">
          <div className="blog-post-card">
            <div 
              className="blog-post-image"
              style={{ backgroundImage: `url(https://images.pexels.com/photos/914682/pexels-photo-914682.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)` }}
            ></div>
            <div className="blog-post-content">
              <h3 className="blog-post-title">St. Andrews Links</h3>
              <p className="blog-post-excerpt">Home of golf with world-renowned course layouts and history dating back to the 15th century.</p>
            </div>
          </div>
          
          <div className="blog-post-card">
            <div 
              className="blog-post-image"
              style={{ backgroundImage: `url(https://images.pexels.com/photos/6859552/pexels-photo-6859552.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)` }}
            ></div>
            <div className="blog-post-content">
              <h3 className="blog-post-title">Pine Valley Golf Club</h3>
              <p className="blog-post-excerpt">Consistently ranked as one of the top golf courses with challenging layouts and pristine conditions.</p>
            </div>
          </div>
          
          <div className="blog-post-card">
            <div 
              className="blog-post-image"
              style={{ backgroundImage: `url(https://images.pexels.com/photos/1473050/pexels-photo-1473050.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)` }}
            ></div>
            <div className="blog-post-content">
              <h3 className="blog-post-title">Mountain View Golf Resort</h3>
              <p className="blog-post-excerpt">Set against breathtaking mountain backdrops with challenging elevation changes and stunning views.</p>
            </div>
          </div>
        </div>
      </section>
      
      <section>
        <h2>Become a Partner</h2>
        <div className="two-column-content">
          <div className="content-card">
            <h3>Benefits for Golf Courses</h3>
            <ul>
              <li>Increased visibility to our growing user base</li>
              <li>Efficient tee time management system</li>
              <li>Reduced administrative overhead</li>
              <li>Marketing support and promotional opportunities</li>
              <li>Data insights and booking analytics</li>
              <li>Custom integration with your existing systems</li>
            </ul>
          </div>
          
          <div className="content-card">
            <h3>Partnership Inquiry</h3>
            <form className="contact-form" style={{ padding: 0, boxShadow: 'none' }}>
              <div className="form-group">
                <label htmlFor="courseName">Course Name</label>
                <input type="text" id="courseName" placeholder="Enter your golf course name" />
              </div>
              
              <div className="form-group">
                <label htmlFor="contactName">Contact Name</label>
                <input type="text" id="contactName" placeholder="Your name" />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" placeholder="your.email@example.com" />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input type="tel" id="phone" placeholder="(555) 123-4567" />
              </div>
              
              <button type="submit" className="form-submit">Request Information</button>
            </form>
          </div>
        </div>
      </section>
      
      <section>
        <h2>Industry Partners</h2>
        <p>
          Beyond golf courses, we collaborate with leading brands in the golf industry to enhance the 
          overall experience for our users. From equipment manufacturers to training academies, our 
          partnerships help golfers improve their game on and off the course.
        </p>
        
        <div className="two-column-content">
          <div className="content-card">
            <h3>Equipment Partners</h3>
            <p>
              We work with top golf equipment manufacturers to bring our users exclusive deals, 
              equipment reviews, and fitting recommendations.
            </p>
          </div>
          
          <div className="content-card">
            <h3>Training Partners</h3>
            <p>
              Our network includes renowned golf academies and instructors who contribute their expertise 
              to our content and offer special programs for GolfScape users.
            </p>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default PartnersPage;
